import { useEffect } from "react";
import { BlogHeader } from "@/components/blog/BlogHeader";
import { BlogLayout } from "@/components/blog/BlogLayout";
import { BlogFiltersSection } from "@/components/blog/BlogFiltersSection";
import { BlogContentSection } from "@/components/blog/BlogContentSection";
import { useBlogPageLogic } from "@/hooks/blog/useBlogPageLogic";

/**
 * Versione client della pagina Blog
 * Questa versione è ottimizzata per l'interattività lato client
 * e include tutte le funzionalità di filtro e ricerca.
 */
const ClientBlogPage = () => {
  const {
    searchInputValue,
    searchTerm,
    selectedCategoryId,
    selectedCategoryName,
    isSearching,
    loaderRef,
    posts,
    loading,
    hasMore,
    loadingMore,
    categories,
    handleSearchChange,
    handleCategoryClick,
    handleResetFilters,
    getPageMetadata,
    isCategoryChanging,
  } = useBlogPageLogic();

  
  const { pageTitle, pageDescription, canonicalPath, structuredData } = getPageMetadata();

  return (
    <BlogLayout 
      title={pageTitle}
      description={pageDescription}
      canonicalPath={canonicalPath}
      structuredData={structuredData}
    >
      <BlogHeader />
      
      <BlogFiltersSection
        searchInputValue={searchInputValue}
        onSearchChange={handleSearchChange}
        categories={categories}
        selectedCategoryId={selectedCategoryId}
        selectedCategoryName={selectedCategoryName}
        onCategoryClick={handleCategoryClick}
        onResetFilters={handleResetFilters}
        isSearching={isSearching}
      />
      
      <BlogContentSection
        posts={posts}
        loading={loading}
        loadingMore={loadingMore}
        hasMore={hasMore}
        searchTerm={searchTerm}
        selectedCategoryName={selectedCategoryName}
        selectedCategoryId={selectedCategoryId}
        onResetFilters={handleResetFilters}
        loaderRef={loaderRef}
        isCategoryChanging={isCategoryChanging}
      />
    </BlogLayout>
  );
};

export default ClientBlogPage;
